export const newCapital = {
  landmarks: [
    "الحي الحكومي",
    "فندق الماسة",
    "محور بن زايد",
    "البرج الأيقوني",
    "مسجد الفتاح العليم",
    "كاتدرائية ميلاد المسيح",
    "الدائري الإقليمي",
    "طريق السويس"
  ],
  title: "ونش انقاذ العاصمة الإدارية | أسرع سيارة سحب بمحور بن زايد والحي الحكومي",
  metaDescription: "خدمة طوارئ وونش انقاذ في العاصمة الإدارية الجديدة. سحب سيارات آمن وسريع من محور بن زايد، الحي الحكومي وفندق الماسة بأحدث أوناش السطحة 24/7.",
  intro: `العاصمة الإدارية الجديدة تمثل مستقبل مصر بمدنها الذكية ومحاورها السريعة الواسعة مثل محور بن زايد والطريق الدائري الإقليمي، إضافة إلى معالمها البارزة كالبرج الأيقوني والحي الحكومي. نظراً للمساحات الشاسعة والمسافات الطويلة بين الأحياء في العاصمة، فإن تعطل سيارتك هناك قد يبدو مقلقاً، خاصة في أوقات متأخرة أو في المناطق قيد الإنشاء.
  هنا يأتي دور ونش انقاذ العاصمة الإدارية، فنحن نمتلك أسطولاً من الأوناش الحديثة المتمركزة داخل وحول العاصمة لتوفير استجابة فورية. سائقونا على دراية تامة بمداخل ومخارج العاصمة ومحاورها، مما يضمن وصولنا إليك بسرعة فائقة لرفع سيارتك بأمان ونقلها إلى أي مركز صيانة داخل أو خارج العاصمة.`,
  highlights: [
    "تغطية شاملة لمختلف أحياء العاصمة مثل الحي الحكومي وحي المال والأعمال",
    "سرعة الوصول للأعطال على محور بن زايد والدائري الإقليمي المحيط بالعاصمة",
    "أوناش مسطحة (Flatbed) متطورة لحماية السيارات الفارهة والحديثة",
    "خدمة على مدار 24 ساعة لخدمة السكان، الموظفين، والزوار"
  ],
  safetyTips: [
    "بسبب سرعة السيارات على محور بن زايد والدائري الإقليمي، اركن سيارتك أقصى اليمين وشغّل أنوار التحذير فوراً.",
    "إذا كنت في منطقة قيد الإنشاء داخل العاصمة، حاول إرسال موقعك الدقيق (Location) لتسهيل وصول الونش إليك.",
    "لا تترك سيارتك بمفردها على الطرق السريعة ليلاً؛ انتظر بداخلها بعد تأمين الموقع بالمثلث العاكس حتى نصلك."
  ],
  faqs: [
    {
      q: "هل يمكنكم إرسال ونش إلى الحي الحكومي أو فندق الماسة؟",
      a: "نعم، لدينا تصاريح ومعرفة تامة بكافة مداخل العاصمة الإدارية، ويمكننا الوصول للحي الحكومي أو فندق الماسة بسرعة وسهولة."
    },
    {
      q: "سيارتي كهربائية (EV) وتعطلت في العاصمة الإدارية، هل الونش مناسب لها؟",
      a: "بالتأكيد، السيارات الكهربائية تتطلب رفعاً كاملاً عن الأرض لتجنب تلف البطاريات أو المحركات الكهربائية. نحن نستخدم أوناش السطحة المتطورة المخصصة لهذا الغرض."
    },
    {
      q: "كم من الوقت يستغرق وصول الونش إلى البرج الأيقوني أو حي الأعمال؟",
      a: "بفضل انتشار سياراتنا الاستراتيجي داخل العاصمة، يستغرق وصولنا عادة ما بين 15 إلى 20 دقيقة كحد أقصى."
    },
    {
      q: "هل تنقلون السيارات من العاصمة الإدارية إلى القاهرة الجديدة؟",
      a: "نعم، نوفر خدمة نقل آمنة وسريعة لسيارتك من العاصمة الإدارية إلى أي مركز صيانة أو توكيل في التجمع أو مدينة نصر أو أي منطقة أخرى."
    }
  ],
  seoText: `
    <h2>أسرع خدمة ونش طوارئ في العاصمة الإدارية الجديدة</h2>
    <p>مع التطور العمراني الهائل في العاصمة الإدارية وانتقال الآلاف للعمل والسكن بها، أصبحت الحاجة لخدمات طوارئ السيارات ضرورة ملحة. المسافات الطويلة بين الأحياء ومحاور مثل بن زايد الشمالي والجنوبي تجعل من ونش انقاذ العاصمة الإدارية رفيق دربك الآمن. نحن نلتزم بتقديم خدمة تتناسب مع رقي وتطور المدينة، معتمدين على أحدث تكنولوجيا السحب والإنقاذ.</p>

    <h3>تجهيزات مخصصة للسيارات الحديثة والكهربائية</h3>
    <p>الغالبية العظمى من السيارات التي تجوب شوارع العاصمة هي سيارات حديثة ذات أنظمة تعليق متطورة أو سيارات كهربائية (EV). هذا النوع من السيارات يتطلب دقة وعناية فائقة عند الرفع. أوناش السطحة الهيدروليكية الخاصة بنا تضمن رفع سيارتك أفقياً بالكامل وتثبيتها بأحزمة متخصصة، مما يوفر حماية 100% ضد الخدوش أو الأعطال الميكانيكية الإضافية.</p>

    <h3>تواصل سريع مع شرق القاهرة والقاهرة الجديدة</h3>
    <p>نظراً لارتباط العاصمة الإدارية الوثيق بمدن شرق القاهرة، فنحن نعمل كمنظومة متكاملة لخدمتك طوال رحلتك. إذا كنت قادماً من التجمع وتعطلت في منتصف الطريق، فإن <a href="/areas/التجمع الخامس">ونش انقاذ التجمع الخامس</a> سيدعمك. وإذا كانت وجهتك عبر طريق السويس نحو العاصمة، فيمكنك الاستعانة بـ <a href="/areas/مدينتي">ونش انقاذ مدينتي</a>. نضمن لك شبكة أمان تغطي كافة خطواتك ومساراتك.</p>
    <p>سواء كنت موظفاً في الحي الحكومي أو زائراً للمدينة، احتفظ برقمنا لضمان استجابة فورية لأي طارئ على الطريق.</p>
  `
};
